import * as React from "react";
import { useContext } from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import { ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import { toast } from "react-toastify";
import { EditProjectContext } from "../../../EditProjectContext";
import { getDropDownListOfValidShippingFrequencies } from "./GetDropDownListOfValidShippingFrequencies";
import { setSameEngineeredSFOnSameSpdrOnEveryRoute } from "./SetSameEngineeredSFOnSameSpdrOnEveryRoute";
import { setSameEngineeredSFOnSameSpdrOrPdsrOnLtlPipeline } from "./SetSameEngineeredSFOnSameSpdrOrPdsrOnLtlPipeline";
import { SfMultiColumnDropDown } from "./SfMultiColumnDropDown";
import { setSameEngineeredSFOnSamePdsrOnEveryRoute } from "./SetSameEngineeredSFOnSamePdsrOnEveryRoute";

const notifyShipFrequencyChangedOnRoutes = (updatedRoutes: Array<string | undefined>): void => {
  if (updatedRoutes.length > 0) {
    toast(
      `Shipping Frequency was also changed in following FTL Routes: ${updatedRoutes.toLocaleString()}`,
      {
        type: "info",
      }
    );
  }
};

export const EngineeredSFDropdownCell = ({ ...props }: GridCellProps) => {
  const { project, setProject } = useContext(EditProjectContext);
  const { dataItem, field } = props;
  const localizedData = getDropDownListOfValidShippingFrequencies(project.ValidShippingFrequencies);

  const handleChange = (e: ComboBoxChangeEvent) => {
    if (!e.target.value) {
      return;
    }

    const { value } = e.target.value;

    const isSpdr = dataItem.SpdrId !== undefined;
    if (isSpdr) {
      handleChangeSpdr(value);
    } else {
      handleChangePdsr(value);
    }
  };

  function handleChangeSpdr(value: number): void {
    const { updatedRoutes, ftlWithNewShipFrequency } = setSameEngineeredSFOnSameSpdrOnEveryRoute(
      project,
      dataItem,
      value
    );

    const updatedLtlPipelines = setSameEngineeredSFOnSameSpdrOrPdsrOnLtlPipeline(
      project,
      dataItem.SpdrId,
      value
    );

    notifyShipFrequencyChangedOnRoutes(updatedRoutes);

    setProject({
      ...project,
      FTLRoutes: ftlWithNewShipFrequency,
      ltlPipelines: updatedLtlPipelines,
    });
  }

  const handleChangePdsr = (value: number): void => {
    const { updatedRoutes, ftlWithNewShipFrequency } = setSameEngineeredSFOnSamePdsrOnEveryRoute(
      project,
      dataItem,
      value
    );

    const updatedLtlPipelines = setSameEngineeredSFOnSameSpdrOrPdsrOnLtlPipeline(
      project,
      dataItem.PdsrId,
      value
    );

    notifyShipFrequencyChangedOnRoutes(updatedRoutes);

    setProject({
      ...project,
      FTLRoutes: ftlWithNewShipFrequency,
      ltlPipelines: updatedLtlPipelines,
    });
  };

  const myField = field || "";
  const dataValue = dataItem[myField] === null ? "" : dataItem[myField];

  return (
    <td>
      {dataItem.inEdit ? (
        <SfMultiColumnDropDown value={dataValue} onChange={handleChange} label="" />
      ) : (
        localizedData.find((val) => val.value === dataValue)?.value
      )}
    </td>
  );
};
